import { faCalendarExclamation } from '@fortawesome/pro-solid-svg-icons';
import { Button } from 'corso-admin-ui';
import { Link } from 'react-router-dom';
import PageStatus from '~/components/PageStatus';

export default function SubscriptionExpired() {
  return (
    <PageStatus
      title="Subscription Expired"
      detail="You have reached the end of your subscription. To regain access, simply reach out to continue using the Corso app."
      icon={faCalendarExclamation}
    >
      <Button asChild variant="primary" className="w-full" size="lg">
        <Link to="https://corso.com/book-a-time" target="_blank">
          Contact Us
        </Link>
      </Button>
    </PageStatus>
  );
}
